import React, { useEffect, useRef } from 'react';
import { useAuthContext } from '../contexts/AuthContext';
import AuthModal from './auth/AuthModal';
import { setGlobalAuthModal } from '../api/instance';

const GlobalAuthModal = () => {
  const { isAuthModalOpen, defaultTab, openAuthModal, closeAuthModal } = useAuthContext();
  const scrollPositionRef = useRef(0);

  // Register this modal with the API instance
  useEffect(() => {
    setGlobalAuthModal({ openAuthModal });
  }, [openAuthModal]);

  // Handle scroll position preservation
  useEffect(() => {
    if (isAuthModalOpen) {
      // Save current scroll position
      scrollPositionRef.current = window.pageYOffset || document.documentElement.scrollTop;
      
      // Prevent body scroll but preserve position
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPositionRef.current}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    } else {
      // Restore scroll position
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      
      // Restore scroll position
      if (scrollPositionRef.current !== undefined) {
        window.scrollTo(0, scrollPositionRef.current);
      }
    }

    // Cleanup function
    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
    };
  }, [isAuthModalOpen]);

  return (
    <AuthModal
      isOpen={isAuthModalOpen}
      onClose={closeAuthModal}
      defaultTab={defaultTab}
      onSuccess={() => {
        closeAuthModal();
        window.location.reload();
      }}
    />
  );
};

export default GlobalAuthModal;
